import firebaseService from './firebaseService';

export default firebaseService;



// WEBPACK FOOTER //
// ./src/firebaseService/index.js